<template>
	<section
		class="media_and_text"
		:style="cssVars"
	>
		<div
			class="container"
			:class="{ flip_horizontally: flip_horizontally }"
		>
			<div
				class="media_and_text__inner"
				:class="{ flip_horizontally: flip_horizontally }"
			>

				<div
					class="media_and_text__inner__text"
					:class="{ flip_horizontally: flip_horizontally }"
				>
					<div class="inner">
						<div class="content_container">
							<h2
								v-if="title"
								v-html="title"
							></h2>

							<div
								class="body"
								v-if="text"
								v-html="text"
							></div>
						</div>

						<div class="cta_container">
							<primary-button
								v-if="parsedImageOrVideo === 'image' && parsedPrimaryButton || data_source != 'module' && parsedImageOrVideo != 'video' && parsedPrimaryButton"
								:link="parsedPrimaryButton.url ? parsedPrimaryButton : false"
								:label="parsedPrimaryButton.title ? parsedPrimaryButton.title : null"
							></primary-button>

							<video-button
								v-else-if="parsedImageOrVideo === 'video'"
								:label="'Play Video'"
								:video_source="parsedVideo"
							></video-button>
						</div>
					</div>
				</div>

				<div
					class="media_and_text__inner__image"
					:class="{ flip_horizontally: flip_horizontally }"
					v-if='parsedImage'
				>
					<img
						:src="parsedImage.url ? parsedImage.url : parsedImage"
						:alt="title"
						:class="{ flip_horizontally: flip_horizontally }"
					/>

					<!-- <svg
						class='device'
						width="1134"
						height="545"
						viewBox="0 0 1134 545"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M165.422 222.479C136.843 212.947 108.554 203.512 116.255 196.011C129.059 183.541 183.41 158.588 244.566 149.846C304.815 141.234 391.396 68.3333 431.579 34.4999C432.184 33.9905 432.778 33.4899 433.362 32.9985C472.715 -0.126293 558.945 -8.0277 600.506 10.7769C620.38 19.7692 636.275 19.9735 653.734 20.1979C672.784 20.4428 693.695 20.7116 723.668 32.4486C756.172 45.1772 796.984 86.5383 834.475 124.534C863.235 153.681 890.041 180.848 909.644 191.59C943.481 210.131 979.657 203.043 1005.79 197.921C1014.53 196.208 1022.15 194.715 1028.18 194.475C1052.25 193.519 1074.38 214.915 1074.38 214.915C1061.87 215.846 1049.45 217.727 1037.22 220.544C1031.01 222.044 1024.44 224.696 1017.14 227.647C1002.76 233.456 985.52 240.42 962.456 242.03C946.742 243.128 934.158 244.532 923.808 247.095C924.666 247.363 925.511 247.614 926.343 247.848C972.652 260.876 1014.61 242.112 1044.92 228.555C1055.06 224.018 1063.9 220.065 1071.16 218.081C1100.13 210.166 1133.02 229.945 1133.02 229.945C1118.09 234.587 1103.53 240.36 1089.47 247.213C1082.33 250.781 1075.1 255.848 1067.05 261.486C1051.21 272.577 1032.22 285.876 1004.66 294.305C963.089 307.019 940.574 317.261 927.878 338.958C921.077 350.582 912.278 371.513 903.165 393.192C895.269 411.975 887.137 431.32 879.862 445.661C869.243 466.597 838.327 471.873 806.971 477.225C792.059 479.769 777.048 482.331 764.072 486.602C744.888 492.917 726.03 503.993 708.081 514.535C688.36 526.118 669.736 537.056 652.983 540.326C624.401 545.906 577.39 544.962 526.903 543.948C520.862 543.827 514.773 543.704 508.658 543.592C484.097 543.141 461.992 534.707 441.308 526.815C413.806 516.321 388.814 506.785 363.893 518.245C320.227 538.323 276.571 543.708 247.289 544.061C229.392 544.277 212.252 539.497 195.06 534.702C184.123 531.652 173.166 528.596 161.979 526.817C141.541 523.566 130.927 519.143 115.391 512.669C109.056 510.028 101.902 507.047 92.9298 503.665C82.9135 499.89 69.9268 496.28 56.8812 492.653C29.5835 485.065 2.02845 477.405 0.892857 468.009C-0.787439 454.123 34.7822 411.62 106.629 383.829C152.262 366.178 203.689 312.993 245.009 263.392C239.175 260.012 234.186 256.436 228.141 252.103C223.669 248.897 218.619 245.277 212.222 241.016C203.417 235.151 184.356 228.794 165.422 222.479Z"
							fill="#5D8D7B"
						/>
					</svg> -->

				</div>

				<div
					class="media_and_text__inner__image"
					:class="{ flip_horizontally: flip_horizontally }"
					v-if='parsedVideoPoster'
				>
					<img
						:src="parsedVideoPoster.url ? parsedVideoPoster.url : parsedVideoPoster"
						:alt="title"
						:class="{ flip_horizontally: flip_horizontally }"
					/>

					<!-- <svg
						class='device'
						width="1134"
						height="545"
						viewBox="0 0 1134 545"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M165.422 222.479C136.843 212.947 108.554 203.512 116.255 196.011C129.059 183.541 183.41 158.588 244.566 149.846C304.815 141.234 391.396 68.3333 431.579 34.4999C432.184 33.9905 432.778 33.4899 433.362 32.9985C472.715 -0.126293 558.945 -8.0277 600.506 10.7769C620.38 19.7692 636.275 19.9735 653.734 20.1979C672.784 20.4428 693.695 20.7116 723.668 32.4486C756.172 45.1772 796.984 86.5383 834.475 124.534C863.235 153.681 890.041 180.848 909.644 191.59C943.481 210.131 979.657 203.043 1005.79 197.921C1014.53 196.208 1022.15 194.715 1028.18 194.475C1052.25 193.519 1074.38 214.915 1074.38 214.915C1061.87 215.846 1049.45 217.727 1037.22 220.544C1031.01 222.044 1024.44 224.696 1017.14 227.647C1002.76 233.456 985.52 240.42 962.456 242.03C946.742 243.128 934.158 244.532 923.808 247.095C924.666 247.363 925.511 247.614 926.343 247.848C972.652 260.876 1014.61 242.112 1044.92 228.555C1055.06 224.018 1063.9 220.065 1071.16 218.081C1100.13 210.166 1133.02 229.945 1133.02 229.945C1118.09 234.587 1103.53 240.36 1089.47 247.213C1082.33 250.781 1075.1 255.848 1067.05 261.486C1051.21 272.577 1032.22 285.876 1004.66 294.305C963.089 307.019 940.574 317.261 927.878 338.958C921.077 350.582 912.278 371.513 903.165 393.192C895.269 411.975 887.137 431.32 879.862 445.661C869.243 466.597 838.327 471.873 806.971 477.225C792.059 479.769 777.048 482.331 764.072 486.602C744.888 492.917 726.03 503.993 708.081 514.535C688.36 526.118 669.736 537.056 652.983 540.326C624.401 545.906 577.39 544.962 526.903 543.948C520.862 543.827 514.773 543.704 508.658 543.592C484.097 543.141 461.992 534.707 441.308 526.815C413.806 516.321 388.814 506.785 363.893 518.245C320.227 538.323 276.571 543.708 247.289 544.061C229.392 544.277 212.252 539.497 195.06 534.702C184.123 531.652 173.166 528.596 161.979 526.817C141.541 523.566 130.927 519.143 115.391 512.669C109.056 510.028 101.902 507.047 92.9298 503.665C82.9135 499.89 69.9268 496.28 56.8812 492.653C29.5835 485.065 2.02845 477.405 0.892857 468.009C-0.787439 454.123 34.7822 411.62 106.629 383.829C152.262 366.178 203.689 312.993 245.009 263.392C239.175 260.012 234.186 256.436 228.141 252.103C223.669 248.897 218.619 245.277 212.222 241.016C203.417 235.151 184.356 228.794 165.422 222.479Z"
							fill="#5D8D7B"
						/>
					</svg> -->

				</div>
			</div>
		</div>
	</section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
import VideoButton from './VideoButton.vue';

export default {
	data() {
		return {
			theModalStatus: false,
		};
	},

	props: {
		title: {},
		tag: {},
		text: {},
		primary_button: {},
		image: {},
		video: {},
		video_poster: {},
		image_or_video: {},
		text_alignment: {},
		flip_horizontally: {},
		size: {},
		data_source: {},
		data: {},
	},

	computed: {
		fadeDirection() {
			if (this.flip_horizontally === '1') {
				return 'fade-left';
			} else {
				return 'fade-right';
			}
		},

		parsedData() {
			if (this.data) {
				return JSON.parse(this.data);
			} else {
				return null;
			}
		},

		fadeDirectionAlt() {
			if (this.flip_horizontally === '1') {
				return 'fade-right';
			} else {
				return 'fade-left';
			}
		},

		parsedImage() {
			if (this.image) {
				try {
					return JSON.parse(this.image);
				} catch (e) {
					return this.image;
				}
			} else {
				return null;
			}
		},

		parsedVideoPoster() {
			if (this.video_poster) {
				return JSON.parse(this.video_poster);
			} else {
				return null;
			}
		},

		parsedVideo() {
			if (this.video) {
				try {
					return JSON.parse(this.video);
				} catch (e) {
					return this.video;
				}
			} else {
				return null;
			}
		},

		parsedPrimaryButton() {
			if (this.primary_button) {
				try {
					return JSON.parse(this.primary_button);
				} catch (e) {
					return this.primary_button;
				}
			} else {
				return null;
			}
		},

		parsedImageOrVideo() {
			if (this.image_or_video) {
				try {
					return JSON.parse(this.image_or_video);
				} catch (e) {
					return this.image_or_video;
				}
			} else {
				return null;
			}
		},

		flipHorizontally() {
			if (this.flip_horizontally === '1') {
				return 'Yes';
			} else {
				return 'No';
			}
		},

		cssVars() {
			return {
				'--text-alignment': this.text_alignment
					? this.text_alignment
					: 'space-between',
				'--white': this.background_colour,
				'--padding-top': this.parsedData.padding_top
					? this.parsedData.padding_top + 'px'
					: '80px',
				'--padding-bottom': this.parsedData.padding_bottom
					? this.parsedData.padding_bottom + 'px'
					: '80px',
				'--padding-top-mobile': this.parsedData.padding_top_mobile
					? this.parsedData.padding_top_mobile + 'px'
					: '40px',
				'--padding-bottom-mobile': this.parsedData.padding_bottom_mobile
					? this.parsedData.padding_bottom_mobile + 'px'
					: '40px',
				'--size': this.size ? this.size : '1 / span 12',
				'--text-colour': this.parsedData.text_colour
					? this.parsedData.text_colour
					: false,
				'--background-colour': this.parsedData.background_colour
					? this.parsedData.background_colour
					: false,
					'--shape-colour': this.parsedData.shape_colour
					? this.parsedData.shape_colour
					: false,
			};
		},
	},

	watch: {},

	methods: {
		getModalData(arg) {
			this.theModalStatus = arg;
			return arg;
		},
	},

	components: {
		PrimaryButton,
		VideoButton,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.media_and_text {
	/* max-height: 500px; */
	overflow: unset !important;
	padding-top: var(--padding-top);
	padding-bottom: var(--padding-bottom);
	position: relative;
	background: var(--background-colour);
	overflow: hidden !important;

	@media (max-width: $mobile-xl) {
		max-height: unset;
		overflow-x: hidden;
		padding-top: var(--padding-top-mobile);
		padding-bottom: var(--padding-bottom-mobile);
	}

	.container {
		position: relative;
		padding-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;

		&::after {
			content: '';
			/* background: url('data:image/svg+xml;base64,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'); */
			-webkit-mask-image: url('data:image/svg+xml;base64,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');
			mask-image: url('data:image/svg+xml;base64,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');
			display: flex;
			position: absolute;
			background-color: var(--shape-colour);
			right: -400px;
			padding-right: 200px;
			padding-left: unset;
			top: 15px;
			/* bottom: -200px; */
			width: 1000px;
			height: 700px;
			z-index: 0;
			transform: scaleX(1.45) scaleY(1.25);
			background-repeat: no-repeat;
			mask-repeat: no-repeat;

			@media (max-width: 1400px) {
				display: none;
			}

			@media (max-width: $mobile-xl) {
				display: flex;
				right: 0;
				padding-right: 0;
				padding-left: unset;
				width: 100%;
				transform: scaleX(-1.1) scaleY(0.65);
				top: -140px;
				left: -80px;
			}
		}

		@media (max-width: $mobile-xl) {
			padding-top: 0;
			padding-bottom: 0;
			padding-left: var(--gutter-mobile);
			padding-right: var(--gutter-mobile);
		}

		&.flip_horizontally {
			&::after {
				content: '';
				/* background: url('data:image/svg+xml;base64,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'); */
				-webkit-mask-image: url('data:image/svg+xml;base64,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');
				mask-image: url('data:image/svg+xml;base64,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');
				display: flex;
				position: absolute;
				background-color: var(--shape-colour);
				left: -400px;
				padding-left: 200px;
				padding-right: unset;
				top: 15px;
				/* bottom: -200px; */
				width: 1000px;
				height: 700px;
				z-index: 0;
				transform: scaleX(-1.45) scaleY(1.25);
				background-repeat: no-repeat;
				mask-repeat: no-repeat;

				@media (max-width: 1400px) {
					display: none;
				}

				@media (max-width: $mobile-xl) {
					display: flex;
					left: 0;
					padding-right: 0;
					width: 100%;
					transform: scaleX(1.1) scaleY(0.65);
					top: -140px;
					right: -80px;
				}
			}
		}
	}

	&__inner {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: 0;
		grid-column: span 12;

		@media (max-width: $mobile-xl) {
			grid-template-columns: 1fr 1fr;
			grid-column: 1 / span 4;
		}

		&.flip_horizontally {
			padding-bottom: unset;

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
			}
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: 1fr;
			column-gap: 0;
			// row-gap: var(--spacer);
			grid-column: span 4;
		}

		.video {
			grid-column: 6 / span 7;
			aspect-ratio: 690 / 470;
			position: relative;
			height: 500px;
			overflow: hidden;
			position: relative;
			/* border-left: var(--border); */

			@media (max-width: $mobile-xl) {
				height: 240px;
				border-left: unset;
				/* border-bottom: var(--border); */
			}

			&.flip_horizontally {
				order: 0;
				justify-content: flex-end;
				grid-column: 1 / span 7;
				border-left: unset;
				/* border-right: var(--border); */

				@media (max-width: $mobile-xl) {
					order: 0;
					margin-right: 0;
					min-height: auto;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				margin-right: 0;
				min-height: auto;
			}
		}

		&__image {
			grid-column: 6 / span 7;
			opacity: 1;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			align-items: center;
			box-sizing: border-box;
			/* height: 500px; */
			aspect-ratio: 3 / 2;
			/* height: 447px; */
			/* overflow: hidden; */
			position: relative;
			padding-right: 0;
			z-index: 5;

			/* border-left: var(--border); */

			.device {
				display: flex;
				position: absolute;
				right: -150px;
				bottom: -50px;
				/* width: calc(100% - 200px);
				height: calc(100% - 16px); */
				z-index: 0;
				display: none;

				path {
					fill: var(--background-colour);
				}

				@media (max-width: $mobile-xl) {
					width: calc(100% - 8px);
					height: 90%;
					top: -25px;
					right: -24px;
				}
			}

			@media (max-width: $mobile-xl) {
				height: unset;
				aspect-ratio: 329 / 227;
				border-left: unset;
				padding-right: unset;
				/* border-bottom: var(--border); */
			}

			&.flip_horizontally {
				order: 0;
				justify-content: flex-end;
				grid-column: 1 / span 7;
				border-left: unset;
				padding-left: 0;
				padding-right: unset;
				/* border-right: var(--border); */

				.device {
					display: none;
					position: absolute;
					left: -150px;
					transform: scaleX(-1);
					/* width: calc(100% - 200px);
				height: calc(100% - 16px); */
					z-index: 0;

					path {
						fill: var(--background-colour);
					}

					@media (max-width: $mobile-xl) {
						width: calc(100% - 8px);
						height: 90%;
						top: -25px;
						right: -24px;
					}
				}

				@media (max-width: $mobile-xl) {
					order: 0;
					margin-right: 0;
					min-height: auto;
					padding-left: unset;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 7;
				margin-right: 0;
				min-height: auto;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				transition: 0.2s ease all;
				transform: scale(1);
				object-position: top;
				position: relative;
				z-index: 10;

				/* &:hover {
					transition: 0.2s ease all;
					transform: scale(1.1);
				} */

				@media (max-width: $mobile-xl) {
					object-fit: cover;
				}
			}
		}

		&__text {
			grid-column: 1 / span 4;
			background: transparent 0% 0% no-repeat padding-box;
			opacity: 1;
			display: flex;
			flex-direction: column;
			gap: var(--gutter-tablet-desktop);
			font: normal normal normal 17px/24px var(--primary-font-family);
			/* padding: 100px 0 100px; */
			gap: 50px;
			position: relative;
			z-index: 6;

			@media (max-width: $mobile-xl) {
				gap: 16px;
				order: 1;
			}

			&.flip_horizontally {
				grid-column: 9 / span 4;
				order: 1;

				@media (max-width: $mobile-xl) {
					order: 1;
					grid-column: span 1;
					margin-right: 0;
					/* aspect-ratio: 4 / 3.5; */
					min-height: auto;
				}

				.inner {
					grid-column: 12 / span 12;
					padding: 40px 32px 32px 48px;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						/* border-left: var(--border); */
						border-right: unset;
						padding: 32px 0;
					}
				}
			}

			h2 {
				color: var(--text-colour);
				margin: 0;
				margin-bottom: 24px;
				z-index: 10;
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				// padding: 0 var(--spacer);

				h2 {
					text-align: left;
				}

				.the_subtitle {
					text-align: center;
				}
			}

			.wpforms-container-full,
			.wpcf7-form {
				margin-top: var(--spacer);
			}

			.the_subtitle {
				font: normal normal bold 18px/28px var(--primary-font-family);
				z-index: 10;

				&::v-deep {
					p {
						margin: 0 0 32px;
						font: normal normal bold 18px/28px var(--primary-font-family);
						color: var(--text-colour);

						@media (max-width: $mobile-xl) {
							text-align: left;
						}

						&:last-of-type {
							margin: 0 0 0;
						}
					}
				}
			}

			.text,
			.body {
				/* font: normal normal 500 var(--body-font-size)
					var(--primary-font-family); */
				/* color: var(--text-colour); */
				z-index: 10;

				&::v-deep {
					p {
						margin: 0 0 32px;
						font: normal normal normal 16px/24px var(--primary-font-family);
						color: var(--text-colour);

						@media (max-width: $mobile-xl) {
							text-align: left;
						}

						&:last-of-type {
							margin: 0 0 0;
						}
					}

					ul,
					ol {
						display: flex;
						flex-direction: column;
						margin: var(--gutter-tablet-desktop) 0 var(--gutter-tablet-desktop);
						padding: 0 0 0 12px;

						li {
							font: normal normal normal var(--body-font-size)
								var(--primary-font-family);
						}
					}
				}
			}

			.cta_container {
				margin-top: 0;
				/* z-index: 10; */
				/* max-width: calc(100% - calc(113px - 54px)); */
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				gap: 24px;
				min-width: 100%;

				@media (max-width: $mobile-xl) {
					margin-top: (32px - 16px);
					text-align: left;
					display: flex;
					flex-wrap: wrap;
					gap: var(--spacer-mobile);
				}

				.site_button,
				.video_button {
					// margin-right: 16px;

					border-color: var(--text-colour);

					&::v-deep {
						a {
							border-color: var(--text-colour);
						}

						.site_button_title {
							color: var(--text-colour);
						}

						.video_icon {
							path {
								fill: var(--text-colour);
							}
						}

						.external_link_icon {
							path {
								stroke: var(--text-colour);
							}
						}

						.cta {
							path {
								fill: var(--text-colour);
							}
						}

						&:hover {
							.site_button_title {
								color: var(--white);
							}

							border-color: var(--dark-green);

							.external_link_icon {
								path {
									stroke: var(--white);
								}
							}

							.video_icon {
								path {
									fill: var(--white);
								}
							}

							.cta {
								path {
									fill: var(--white);
								}
							}
						}
					}
				}

				/* .site_button_primary {
					padding-left: 0;
				} */
			}

			.content_device {
				position: absolute;
				right: 0;
				bottom: 0;

				@media (max-width: $mobile-xl) {
					height: 112px;
				}
			}

			.inner {
				grid-column: 2 / span 12;
				min-height: 200px;
				padding: 40px 48px 32px 32px;
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				gap: 40px;
				pointer-events: all;
				justify-content: flex-start;
				height: 100%;

				@media (max-width: $mobile-xl) {
					max-height: unset;
					grid-column: span 4;
					border-left: unset;
					padding: 32px 0;
					gap: 16px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MediaAndText.vue